export default class MobileMenuLevels {
    constructor(button) {
        this.button = button;
        this.mobileMenuContainer = document.querySelector('.mobile-menu__container');
        this.html = document.querySelector('html');
        this.body = document.querySelector('body');
        this.header = document.querySelector('header');
        this.menu = document.querySelector('.mobile-menu');
        this.substitute = document.querySelector('.header-mobile__substitute');
        this.overlay = document.querySelector('.header-mobile__overlay-menu');
        this.modalUndefineRegion = document?.querySelector('.mobile-modal-regions-undefine');
        this.maxDepth = 3;
        this.depth = 0;

        this.eventRegister();
    }

    eventRegister() {
        this.button.addEventListener('click', () => this.toggleMenu());
        this.overlay.addEventListener('click', () => this.toggleMenu());
        this.overlay.addEventListener(
            'touchmove',
            (e) => {
                e.preventDefault();
            },
            {passive: false}
        );
        this.menu.addEventListener('click', (e) => this.handleMenuClick(e));
    }

    toggleMenu() {
        if (!this.menu) return;

        this.menu.classList.toggle('mobile-menu__is-open');
        const isOpen = this.menu.classList.contains('mobile-menu__is-open');

        if (this.button) {
            this.button.setAttribute('aria-expanded', String(isOpen));
        }

        if (!isOpen) {
            this.mobileMenuContainer.style.position = '';
            this.header.style.position = '';
            this.header.style.height = '';
            this.overlay.style.backgroundColor = '';
            this.overlay.style.display = '';
            this.substitute.style.display = '';
            this.substitute.style.height = '';
            this.html.classList.remove('scroll-lock');
            this.body.classList.remove('scroll-lock');
            document.documentElement.overflowY = '';
            if (this.modalUndefineRegion) {
                this.modalUndefineRegion.style.display = '';
            }
            this.reset();
            return;
        }

        this.mobileMenuContainer.style.position = 'static';
        this.header.style.position = 'absolute';
        this.header.style.top = '0';
        this.overlay.style.backgroundColor = '#00000099';
        this.overlay.style.display = 'block';
        this.header.style.height = 'fit-content';
        this.substitute.style.display = 'block';
        this.substitute.style.height = '72px';
        this.html.classList.add('scroll-lock');
        this.body.classList.add('scroll-lock');
        document.documentElement.overflowY = 'hidden';
        if (this.modalUndefineRegion) {
            this.modalUndefineRegion.style.display = 'none';
        }
    }

    handleMenuClick(e) {
        const link = e.target?.closest('.mobile-menu__link');
        if (!link) {
            return;
        }
        if (link.dataset.menuBack === '1') {
            e.preventDefault();
            this.closeLevel(link);
            return;
        }

        const parentLi = link.closest('.mobile-menu__parent-li');
        this.parentUl = parentLi?.parentElement;
        if (!parentLi) return;

        const childUl = parentLi.querySelector(':scope > .mobile-menu__children-ul');
        if (!childUl || this.depth >= this.maxDepth - 1) return;

        e.preventDefault();
        this.openLevel(parentLi, childUl);
    }

    openLevel(parentLi, childUl) {
        this.depth += 1;
        this.savedScrollTop = this.menu.scrollTop;
        if (this.parentUl) {
            this.savedScrollTopParentUl = this.parentUl.scrollTop;
            setTimeout(() => {
                this.parentUl.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }, 1);
            this.parentUl.style.overflowY = 'hidden';
        }
        setTimeout(() => {
            this.menu.scrollTo({
                top: 0,
            });
        }, 200);
        setTimeout(() => {
            this.menu.style.overflowY = 'hidden';
        }, 200);

        this.header.style.overflow = 'hidden';
        if (childUl.parentElement !== this.menu) {
            const placeholder = document.createElement('span');
            placeholder.style.display = 'none';

            childUl.after(placeholder);

            childUl._placeholder = placeholder;
        }

        childUl.classList.remove('mobile-menu__is-open', 'mobile-menu__is-closing');

        void childUl.offsetWidth;

        requestAnimationFrame(() => {
            childUl.classList.add('mobile-menu__is-open');
        });
    }

    closeLevel(backLink) {
        const currentUl = backLink.closest('.mobile-menu__children-ul');
        if (!currentUl) return;

        currentUl.classList.remove('mobile-menu__is-open');
        currentUl.classList.add('mobile-menu__is-closing');

        if (this.depth > 0) this.depth -= 1;

        if (this.depth === 0) {
            this.header.style.overflowY = '';
            this.menu.style.overflowY = '';
            this.menu.scrollTo({
                top: this.savedScrollTop,
                behavior: 'smooth',
            });
        }
        if (this.parentUl) {
            setTimeout(() => {
                this.parentUl.scrollTo({
                    top: this.savedScrollTopParentUl,
                    behavior: 'smooth',
                });
            }, 1);
            this.parentUl.style.overflowY = 'auto';
        }

        setTimeout(() => {
            if (currentUl._placeholder && currentUl._placeholder.parentElement) {
                currentUl._placeholder.before(currentUl);
                currentUl._placeholder.remove();
                delete currentUl._placeholder;
            }
            currentUl.scrollTop = 0;
            currentUl.style.top = '';
            currentUl.style.height = '';
        }, 300);
    }

    reset() {
        this.depth = 0;
        this.savedScrollTop = 0;
        this.savedScrollTopParentUl = 0;
        if (this.header) {
            this.header.style.overflowY = '';
        }
        if (this.menu) {
            this.menu.style.overflowY = '';
            this.menu.scrollTo({
                top: 0,
            });
        }
        if (this.parentUl) {
            this.parentUl.style.overflowY = '';
            this.parentUl.scrollTo({
                top: 0,
            });
        }

        if (!this.menu) {
            return;
        }

        const container = this.menu;
        container.querySelectorAll('.mobile-menu__children-ul').forEach((ul) => {
            ul.classList.remove('mobile-menu__is-open', 'mobile-menu__is-closing');

            if (ul._placeholder && ul._placeholder.parentElement) {
                ul._placeholder.before(ul);
                ul._placeholder.remove();
                delete ul._placeholder;
            }

            ul.style.top = '';
            ul.style.height = '';
        });
    }
    closeMenu() {
        if (!this.menu) return;
        if (!this.menu.classList.contains('mobile-menu__is-open')) return;

        this.toggleMenu();
    }
}
